/* eslint-disable no-unused-vars */
import { EDIT, CHANGEMODE } from "./actionTypes";

const initialState = {
  data: {},
  shouldUpdate: false,
};

export default function formReducer(state = initialState, action) {
  switch (action.type) {
    case EDIT:
      return {
        ...state,
        data: { ...action.payload },
      };
    case CHANGEMODE:
      // return { ...state, shouldUpdate: !state.shouldUpdate };
      return { ...state, shouldUpdate: action.payload };
    default:
      return state;
  }
}
